export default __webpack_public_path__ + "static/media/back-arrow-left.6cbfe536.svg";